import { FC } from 'react'

import { List } from './styles'

const TabHorizontalList: FC = ({ children }) => <List data-testid="tab-horizontal-list">{children}</List>

export default TabHorizontalList
